import React from "react"

import { TeeUpsPage } from "../../pages"

export const ComingUpPage = () => <TeeUpsPage isComingUp />
